import { defineMessages } from 'react-intl-next';

import { ADMIN_ANNOUNCEMENT_BANNER_RENDERER } from '@confluence/named-routes';

import type { CreateAdminAnnouncementBannerMutation_createAdminAnnouncementBanner_adminAnnouncementBannerSetting as CreateAdminAnnouncementBannerSettingsType } from '../queries/__types__/CreateAdminAnnouncementBannerMutation';
import type { UpdateAdminAnnouncementBannerMutation_updateAdminAnnouncementBanner_adminAnnouncementBannerSetting as UpdateAdminAnnouncementBannerSettingType } from '../queries/__types__/UpdateAdminAnnouncementBannerMutation';

export enum MutationType {
	CREATE = 'create',
	UPDATE = 'update',
}

export enum MutationUpdateReason {
	UPDATE = 'update',
	PUBLISH = 'publish',
	TURNOFF = 'turnOff', // This will be deprecated after M2 is fully rolled out
	ARCHIVE = 'archive',
}

export enum MutationSource {
	FORM = 'form',
	TABLE = 'table',
}

export interface HandleOnCompletedProps {
	bannerSettings:
		| CreateAdminAnnouncementBannerSettingsType
		| UpdateAdminAnnouncementBannerSettingType;
	mutationType: MutationType;
	mutationUpdateReason?: MutationUpdateReason;
}

export const ANNOUNCEMENT_HOME_URL = ADMIN_ANNOUNCEMENT_BANNER_RENDERER.toUrl();

// i18n for flag contents is in the getFlagContents.ts file
export const i18n = defineMessages({
	publishTitle: {
		id: 'admin-announcement-banner.publish.title',
		defaultMessage: 'Create announcement',
		description: 'Page title for the banner publish page',
	},
	publishButton: {
		id: 'admin-announcement-banner.footer.publish-button',
		defaultMessage: 'Publish',
		description: 'Text for publish button, shown in the create form and copy form.',
	},
	announcementBreadcrumbs: {
		id: 'admin-announcement-banner.announcement.breadcrumb',
		defaultMessage: 'Announcements',
		description: 'Breadcrumb text to redirect user to Admin Announcement Home.',
	},
	untitledBannerTitle: {
		id: 'admin-announcement-banner.schedule-conflict.default-title',
		defaultMessage: 'Untitled banner',
		description: 'Default title shown for an untitled banner with a scheduling conflict.',
	},
	lookAndFeelLabel: {
		id: 'admin-announcement-banner.section.color-picker.label',
		defaultMessage: 'Look and feel',
		description: 'Label for color picker',
	},
});
